
import './utils/helpers';
import './index.scss';

function importAll(r) {
    r.keys().forEach(r);
}

/* eslint-disable-next-line */
importAll(require.context('./elements/', true, /\.(js|jsx)$/));
